import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../../Assets/Css/SetConfirm.css";
import DoctorIcon from "../../Assets/Images/SVG/DoctorImage.svg";
import CalendarIcon from "../../Assets/Images/SVG/testlog-calendar.svg";

const SetConfirm = ({
  selectedDate,
  nextFollowUpDate,
  selectedSlot,
  onBack,
  onClose,
}) => {
  const [consultationReason, setConsultationReason] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate(); // Initialize useNavigate

  const handleConfirm = () => {
    if (!consultationReason.trim()) {
      setError("Reason for consultation is required.");
      return;
    }
    setError("");

    // Navigate to the /received page after confirmation
    navigate("/received");
  };

  return (
    <div className="set-confirm-wrapper">
      <button className="set-confirm-close" onClick={onClose}>
        ×
      </button>
      <div className="set-confirm-header">
        <h2 className="set-confirm-title">Doctor</h2>
      </div>
      <div className="set-confirm-doctor-section">
        <img
          src={DoctorIcon}
          alt="Doctor"
          className="set-confirm-doctor-image"
        />
        <div className="set-confirm-doctor-info">
          <h3 className="set-confirm-doctor-name">Dr. Luke Leon</h3>
          <p className="set-confirm-doctor-qualification">MBBS, MD</p>
        </div>
      </div>
      <div className="set-confirm-form">
        <div className="set-confirm-form-group">
          <label className="set-confirm-label" htmlFor="date-input">
            Date
          </label>
          <div className="set-confirm-input-wrapper">
            <input
              type="text"
              id="date-input"
              className="set-confirm-input"
              value={selectedDate ? selectedDate : nextFollowUpDate} // Show selected or fallback date
              readOnly
            />
            <img
              src={CalendarIcon}
              alt="Calendar"
              className="set-confirm-icon"
            />
          </div>
        </div>

        <div className="set-confirm-form-group">
          <label className="set-confirm-label" htmlFor="slot-time">
            Slot Time
          </label>
          <input
            type="text"
            id="slot-time"
            className="set-confirm-input"
            value={selectedSlot}
            readOnly
          />
        </div>
        <div className="set-confirm-form-group">
          <label className="set-confirm-label" htmlFor="consultation-reason">
            Reason for Consultation <span className="mandatory">*</span>
          </label>
          <input
            type="text"
            id="consultation-reason"
            className={`set-confirm-input ${error ? "input-error" : ""}`}
            value={consultationReason}
            onChange={(e) => setConsultationReason(e.target.value)}
          />
          {error && <span className="set-confirm-error">{error}</span>}
        </div>
      </div>
      <div className="set-confirm-button-group">
        <button className="set-confirm-back-button" onClick={onBack}>
          Back
        </button>
        <button className="set-confirm-confirm-button" onClick={handleConfirm}>
          Confirm
        </button>
      </div>
    </div>
  );
};

export default SetConfirm;
